import React from 'react';
import StyledTable from '@shared/components/StyledTable';
import { isNumKeyValid } from '../../../utils/numberExtensions';
import MultilineTextWithTooltip from '@shared/components/MultilineTextWithTooltip';

const COLUMNS = [
  {
    title: 'Organizational Unit',
    dataIndex: 'orgUnit',
    width: '20%'
  },
  {
    title: 'Invoice Number',
    dataIndex: 'invoiceNumber',
    width: '15%'
  },
  {
    title: 'Purchase Order Number',
    dataIndex: 'purchaseOrderNumber',
    width: '15%'
  },
  {
    title: 'Description',
    dataIndex: 'description',
    width: '20%',
    render: value => <MultilineTextWithTooltip value={value} maxRowNumber={4} />
  },
  {
    title: 'Invoice Total (USD)',
    dataIndex: 'invoiceTotal',
    width: '10%'
  },
  {
    title: 'Due Date',
    dataIndex: 'dueDate',
    onCell: record => ({
      className: record.isPastDue ? 'past-due-cell' : ''
    }),
    width: '10%'
  },
  {
    title: 'Status',
    dataIndex: 'status',
    width: '10%'
  }
];

/**
 * @typedef {object} InvoicesTableProps
 * @property {boolean} [loading]
 * @property {Array<*>} [data]
 * @property {number} [totalCount]
 * @property {number} [pageSize]
 * @property {number} [pageNumber]
 * @property {(page: number, pageSize: number) => void} [handleChange]
 */

/**
 * @param {InvoicesTableProps} props
 */
const InvoicesTable = props => {
  const { data, totalCount, pageSize, pageNumber, loading, handleChange } = props;

  const handleKeyDown = e => {
    if (!isNumKeyValid(e)) {
      e.preventDefault();
    }
  };

  return (
    <StyledTable
      rowKey='id'
      dataSource={data}
      columns={COLUMNS}
      pagination={{
        showSizeChanger: {
          onInputKeyDown: handleKeyDown
        },
        current: pageNumber,
        pageSize: pageSize,
        total: totalCount,
        onChange: handleChange
      }}
      showSorterTooltip={false}
      loading={loading}
    />
  );
};

export default InvoicesTable;
